import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const inviteTeamNudgeEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-invite-team-nudge-entrypoint" */ './index'),
	),
	getPreloadProps: () => ({}),
});
